<template>
    <e-charts :options="option" :init-options="initOptions" ref="map" autoresize />
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
// import { spawn } from 'child_process'
export default {
    name: 'lineChartNormal',
    components: {
        ECharts
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        chartName: {
            type: String,
            default: '折线图'
        }
    },
    data() {
        return {}
    },
    computed: {
        initOptions() {
            return {
                renderer: 'canvas'
            }
        },
        option() {
            return {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    x: 'center',
                    y: 'bottom',
                    data: [this.chartName]
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.list.map(el => el.name),
                    axisLine: {
                        lineStyle: {
                            color: () => '#ccc'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: () => '#ccc'
                        }
                    }
                },
                series: [
                    {
                        name: this.chartName,
                        type: 'line',
                        data: this.list,
                        color: this.variables.linkColor,
                        // 曲线
                        smooth: true
                    }
                ]
            }
        }
    },
    methods: {}
}
</script>
<style lang="less" scoped>
.echarts {
    width: 100%;
    height: 100%;
}
</style>
